/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2021 Tableau.com
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:

// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function($) {

    $(document).ready(function() {

      // Target subnav cta and any cta with class `cta--reg`
      //$('.tc-subnav .cta, .cta--reg').click(function(e) {

      // Target reg ctas with class `cta--reg`
      $('.cta--reg').click(function(e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $($(this).attr('href')).offset().top-100
        }, 500);
      });

    });

})(jQuery);
